import './Theme.Button.Link.scss';
export default 'ThemeButtonLink';
